// Lib
import React, { useState } from 'react';
import { Guild } from './utils/types';
import { GuildContext } from './utils/contexts/GuildContext';
import { useLocation } from "react-router-dom";

import Docs from "./app/Docs";
import Dashboard from "./app/Dashboard";
import Landing from "./app/Landing";
import LoginApp from "./app/Login";

import Navbar from './components/navbar/navbar';
import { useFetchUser } from './utils/hooks/useFetchUser'
import { Spinner } from './components/misc/Spinner';
import { MoonLoader } from 'react-spinners';
import Player from './app/Player';
import { useCookies } from './utils/hooks/useCookies';


function App() {
  const { cookies_loading } = useCookies()
  const [guild, setGuild] = useState<Guild>();
  const updateGuild = (guild: Guild) => setGuild(guild);
  const location = useLocation()
  const { user, error, loading } = useFetchUser()

  if (cookies_loading) return <Spinner children={<MoonLoader size={40} color="white" />} />

  if (location.pathname !== "/player/panel") document.body.style.backgroundColor = "#1d1d1d"

  return (
    <div>
      {
        loading ? 
        <>
          <Spinner children={<MoonLoader size={40} color="white" />} />
        </> :
        <>
          <GuildContext.Provider value={{ guild, updateGuild }}>
          <Navbar user={user} error={error} loading={loading}/>
            <Landing user={user} error={error} />
            <Docs />
            <LoginApp />
            <Dashboard />
            <Player user={user}/>
          </GuildContext.Provider>
        </>
      }
    </div>
 )
}

export default App